<template>
  <v-app>
    <Menu v-if="showMenu" />
    <v-main>
      <div style="padding: 12px;">
        <RouterView />
        <error-dialog
          v-if="fetchError"
          :error="fetchError"
          @onDialogCancelOrConfirm="onHandleErrorDialogCancelOrConfirm"
        />
        <error-item-dialog
          v-if="itemResults"
          :response="itemResults"
          @onDialogCancelOrConfirm="onHandleErrorItemDialogCancelOrConfirm"
        />
      </div>
    </v-main>

    <GlobalSnackbar />
  </v-app>
</template>

<script setup lang="ts">

import '@/assets/css/global/google_fonts/roboto.css'
import '@/assets/css/global/materialdesign/icons/materialdesignicons.min.css'

import { computed } from "vue";

import { useRoute } from 'vue-router';

import { useAuth } from "@/composables/useAuth";
import { shouldShowMenu } from "@/appNavigation";
import { useGlobalError } from '@/composables/useGlobalError';

import Menu from "@/components/Menu.vue";
import { ErrorDialog, ErrorItemDialog } from "@/components/dialogs";
import GlobalSnackbar from "@/components/base/globalSnackbar/GlobalSnackbar.vue";

const { fetchError, itemResults, clearFetchError, clearItemResults } = useGlobalError();

const auth = useAuth();
const route = useRoute();
auth.restoreFromStorage();

const showMenu = computed(() => shouldShowMenu(route.path, auth.isAuthenticated.value));

const onHandleErrorDialogCancelOrConfirm = () => {
  clearFetchError();
};

const onHandleErrorItemDialogCancelOrConfirm = () => {
  clearItemResults();
};

</script>

<style src="./assets/css/global/base.css"></style>
<style src="./assets/css/global/vuetify.css"></style>
